import { Box, Typography, useMediaQuery, Modal, Button } from '@mui/material';
import React, { memo } from 'react'
import theme from '../../../theme';
import IPhone16Frame from '../../Influencer/Frames/IPhone16Frame';
import BackgroundImageCollections from '../../../media/site_media/background_images/BackgroundImageCollections.webp';
import AndroidPlaystore from '../../../media/site_media/social_icons/play-store.png'
import AppleAppstore from '../../../media/site_media/social_icons/apple-store.png'
import { gtag } from 'ga-gtag';
import { keyframes } from '@emotion/react';
import { useSearchParams } from 'react-router-dom';

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.02); }
  100% { transform: scale(1); }
`;

const MobilePreview = ({ LeftView, mobilePreviewView, url, disablePreview, activeTab }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [searchParams] = useSearchParams()
  const current_page_view = searchParams.get("page");
  const [modalOpen, setModalOpen] = React.useState(false);
  const [storeUrl, setStoreUrl] = React.useState('');
  
  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleStoreClick = (url, eventName, eventCategory, eventLabel) => {
    setStoreUrl(url);
    setModalOpen(true);
    gtag('event', eventName, {
      'event_category': eventCategory,
      'event_label': eventLabel,
    });
  };

  const handleContinueToStore = () => {
    window.open(storeUrl, '_blank');
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        maxWidth: '100vw',
        padding: current_page_view === 'platform' ? {sx: '20px 20px', lg: '40px 40px'} : '0px 0px',
        gap: {xs: '0px ', lg: '60px'},
        position: 'relative'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '100vw',
          flex: { xs: 1, lg: !disablePreview ? 0.75 : 1 },
        }}
      >
        {LeftView}
      </Box>

      {activeTab === 'Platform' && (
        <>
{/* 
      {!disablePreview && <Box
        sx={{
          visibility: 'hidden',
          display: { xs: 'none', lg: 'flex' },
          flex: { xs: 0, lg: 0.25 },
          flexDirection: 'column',
          // justifyContent: 'center', 
          alignItems: 'center',
          pt: '20px',
          scale: { lg: 0.95 },
          position: 'sticky',
          top: '100px',
          alignSelf: 'flex-start'
        }}
      >
        <Box
          sx={{
            width: '350px',
            minWidth: '350px',
            maxWidth: '350px',
            height: { lg: '700px' },
            border: '10px solid #1a1a1a',
            overflow: 'hidden',
            borderRadius: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            backgroundColor: 'var(--rebranding-background-color)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            '&:before': {
              content: '""',
              position: 'absolute',
              top: 0,
              width: '130px',
              height: '20px',
              backgroundColor: '#1a1a1a', 
              borderBottomLeftRadius: '16px',
              borderBottomRightRadius: '16px',
              zIndex: 9999
            }
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              overflowY: 'auto',
              position: 'relative',
              '&::-webkit-scrollbar': {
                display: 'none'
              },
              msOverflowStyle: 'none',
              scrollbarWidth: 'none',

            }}
          >
              {mobilePreviewView}
          </Box>
        </Box>
        
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            mt: '20px',
          }}
        >


          
          <Box
            component="img"
            src={'https://openaccessimages.s3.eu-west-2.amazonaws.com/applestore.png'}
            alt="Download on the App Store"
            onClick={() => {
              handleStoreClick(
                'https://apps.apple.com/us/app/withme/id6477915797',
                'appstore_apple_redirect',
                'IOS App Download',
                'IOS App Download'
              );
            }}
            sx={{
              width: { xs: '120px', sm: '130px' },
              height: 'auto',
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              '&:hover': { transform: 'scale(1.05)' },
            }}
          />
          <Box
            component="img"
            src={'https://openaccessimages.s3.eu-west-2.amazonaws.com/googleplaystore.png'}
            alt="Get it on Google Play"
            onClick={() => {
              handleStoreClick(
                'https://play.google.com/store/apps/details?id=com.withmeapp',
                'appstore_android_redirect',
                'Android App Download',
                'Android App Download'
              );
            }}
            sx={{
              width: { xs: '120px', sm: '130px' },
              height: 'auto',
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              '&:hover': { transform: 'scale(1.05)' },
            }}
          />
        </Box>
      </Box>}

      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="app-store-modal-title"
        aria-describedby="app-store-modal-description"
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', zIndex: 9999}}
      >
        <Box
          sx={{
            position: 'absolute',
            outline: 'none',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            boxSizing: 'border-box',
            width: { xs: '320px', sm: '360px', md: '450px' },
            maxHeight: '80vh',
            overflowY: 'auto',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            boxShadow: 24,
            backgroundColor: '#fff',
            borderRadius: '16px',
            padding: '20px'
          }}
        >
          <Box 
            sx={{ 
              width: '100%', 
              height: '200px', 
              borderRadius: '10px',
              backgroundImage: `url(${BackgroundImageCollections})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2
            }}
          >
            <Box 
              component="img" 
              src={storeUrl.includes('apple') ? 'https://openaccessimages.s3.eu-west-2.amazonaws.com/applestore.png' : 'https://openaccessimages.s3.eu-west-2.amazonaws.com/googleplaystore.png'}
              alt="App Store"
              sx={{ 
                width: '180px',
                height: 'auto',
                // backgroundColor: 'rgba(255, 255, 255, 0.8)',
                borderRadius: '12px',
              }}
            />
          </Box>

          <Typography 
            id="app-store-modal-title" 
            style={{ 
              color: 'black', 
              textAlign: 'left', 
              fontSize: '20px', 
              fontWeight: '600', 
              margin: '25px 0px 10px 0px' 
            }}
          >
            WithMe Mobile App
          </Typography>
          
          <Typography 
            id="app-store-modal-description" 
            style={{ 
              fontWeight: '500', 
              color: '#6E89AF', 
              textAlign: 'left', 
              fontSize: '13px', 
              margin: '0px 0px 30px 0px', 
              lineHeight: '1.5' 
            }}
          >
          The WithMe app acts as your very own native app, allowing your customers to get access to and view only your content.
          </Typography>

          <Box sx={{ 
            borderTop: '1px solid #E4EBF6', 
            display: 'flex', 
            justifyContent: 'space-between', 
            paddingTop: '20px', 
            height: '40px', 
            alignItems: 'center' 
          }}>
            <Button
              variant="outline"
              onClick={handleModalClose}
              sx={{
                height: '45px',
                borderRadius: '8px',
                fontSize: '14px',
                color: 'var(--brand-color)',
                backgroundColor: '#fff',
                border: '2px solid var(--brand-color)',
                boxShadow: 'none',
                fontWeight: '600',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#fff',
                  boxShadow: 'none',
                  color: 'var(--brand-color-hover)',
                  border: '2px solid var(--brand-color-hover)',
                }
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleContinueToStore}
              sx={{
                ml: 1,
                height: '45px',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#fff',
                background: 'var(--brand-color)',
                border: '2px solid var(--brand-color)',
                boxShadow: 'none',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: 'var(--brand-color-hover)',
                  boxShadow: 'none',
                  border: '2px solid var(--brand-color-hover)',
                }
              }}
            >
              Continue to Store
            </Button>
          </Box>
        </Box>
      </Modal> */}



      </>
      )}



    </Box>
  )
}

export default memo(MobilePreview)